import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-energy-sustainable-resources',
  imports: [PillarPagesTemp],
  templateUrl: './energy-sustainable-resources.html',
  styleUrl: './energy-sustainable-resources.scss',
})
export class EnergySustainableResources {

}
